<template>
  <div class="mainBody">
    <div :class="[isAuthenticated ? {pageMainContent} : {}]">
      <b-navbar class="navigationbar" v-show="isAuthenticated">
          <template slot="brand">
              <b-navbar-item tag="router-link" :to="{ path: '/overview' }">
                  <img src="@/assets/referencekit-logo.png" alt="Case studies as a service.">
              </b-navbar-item>
          </template>
          <template slot="end">
            <b-navbar-item v-if="onHomeRoute" class="custom-cta-boldened" tag="router-link" :to="{ path: '/commissioning/firstPart'}">Get started!</b-navbar-item>
            <b-navbar-dropdown label="Account">
              <b-navbar-item tag="router-link" :to="{ path: '/profile'}">
                View your profile: {{ LoggedInProfile.company }}
              </b-navbar-item>
              <b-navbar-item @click="logout">Logout</b-navbar-item>
            </b-navbar-dropdown>
            <b-navbar-item @click="switchContactModal">Contact</b-navbar-item>
          </template>
      </b-navbar>
      <transition :name="transitionName" mode="out-in">
        <router-view/>
      </transition>
    </div>

    <footer class="footer" v-show="isAuthenticated">
      <div class="content has-text-centered">
        <p>
          <strong>ReferenceKit</strong> by <a href="https://www.lostbookofsales.com/author/santeri/" target="_blank">Santeri Liukkonen</a>.
          <br/>
          <br/>
          Go to back to public <a href="https://www.referencekit.com/">Home</a>.
          <br/>
          Pre-Alpha | Version: 0.5
        </p>
      </div>
    </footer>

    <b-modal
      :active.sync="isContactModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Contact Modal"
      aria-modal>
      <ModalContactForm></ModalContactForm>
    </b-modal>
  </div>
</template>

<script>
import ModalContactForm from '@/components/ModalContactForm.vue'

const DEFAULT_TRANSITION = 'fade';

export default {
  components: {
    ModalContactForm
  },
  computed: {
    hideNavbarOnScreen() {
      return this.$route.path === "/login" || 
      this.$route.path === "/login/inactive" || 
      this.$route.path === "/register";
    },
    LoggedInProfile() {
      return this.$store.state.userProfile;
    },
    isAuthenticated() {
      return this.$store.state.userProfile.email
    },
    onHomeRoute() {
      return this.$route.name === "Overview"
    }
  },
  data: function() {
    return {
      // Don't add custom style below if on Login screen
      pageMainContent: "pageMainContent",
      prevHeight: 0,
      transitionName: DEFAULT_TRANSITION,
      isContactModalActive: false
    }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout");
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    switchContactModal: function() {
      this.isContactModalActive = !this.isContactModalActive
    }
  }
}
</script>

<style scoped>
/* One-off items */
.custom-cta-boldened {
  font-weight: bold;
  color: #0378ff;
}
.mainBody {
  position: relative;
  min-height: 100vh;
}
.pageMainContent {
  padding-bottom: 240px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.navbar-item img {
  max-height: 1.2rem;
}
.router-link-exact-active .navbar-item {
  color: #7957d5;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.15s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-active {
  opacity: 0
}
.slide-left-ent er-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.15s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

/* Custom desktop & mobile styles */
@media only screen and (min-width: 1024px) {
  .navigationbar {
    padding-left: 8%;
    padding-right: 8%;
  }
}
</style>